export const referralHelp = {
  referral_link: {
    title: "MY REFERRAL LINK",
    description:
      "This is your referral link. It gives you 5% cashback from referrals who create their own NFT collections and individual NFTs/SBTs.",
  },
  partner_link: {
    title: "MY PARTNERS LINK",
    description:
      "This is your partner link. It gives you custom cashback from referrals. To become a partner, you need to fill out the apply form.",
  },
  claim: {
    title: "CLAIM",
    description:
      "We will finish the Claim mechanism in the next big update.If you have some issues about your stats, plz reach us in our socials.",
  },
};
